import React from 'react';
import {TimeRangePicker} from "../Control";
import {useField} from "formik";
import FieldHelp from "./FieldHelp";

// Component ----

type TimeRangeFieldProps = {
  name: string
  help?: string
}

function TimeRangeField({name, help}: TimeRangeFieldProps) {
  const [field, meta, {setValue, setTouched}] = useField(name)

  function handleChange({expression}: {expression: string}) {
    setTouched(true)
    setValue(expression)
  }

  // Error state
  const hasError = meta.touched && !!meta.error

  return (
    <div>
      <TimeRangePicker
        name={name}
        value={field.value}
        onChange={handleChange}
      />

      {(!!help || hasError) &&
        <FieldHelp isError={hasError}>
          {hasError ? meta.error : help}
        </FieldHelp>
      }
    </div>
  );
}

export default TimeRangeField;